var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light h-100"},[(_vm.visible)?_c('NavBar',{attrs:{"isLoggedIn":this.$store.getters.loggedIn,"isAdmin":this.$store.getters.isAdmin,"account":_vm.account}}):_c('LoginBar'),_c('router-view',{attrs:{"account":_vm.account}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }